import React, { useEffect, useId, useState } from 'react';

type CheckboxFieldProps = {
  fieldName: string;
  values?: {
    label: string;
    value: string | number;
    image?: string;
    imageAlt?: string;
    isImage?: boolean;
  }[];
  setDisabled: (disabled: boolean) => void;
};

export const SKIP_VALUE = 'skip';

export const CheckboxField = ({
  fieldName,
  values,
  setDisabled
}: CheckboxFieldProps) => {
  const id = useId();
  const [selectedValues, setSelectedValues] = useState<string[]>([]);
  const containerRef = React.useRef<HTMLDivElement>(null);

  const handleInputChage = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    let values = [...selectedValues];
    const index = values.indexOf(value);
    if (index > -1) {
      values.splice(index, 1);
    } else {
      if (value === SKIP_VALUE) {
        values = [value];

        const inputs = containerRef.current?.querySelectorAll(
          'input[type="checkbox"]'
        ) as NodeListOf<HTMLInputElement>;

        inputs.forEach(input => {
          if (input.value !== SKIP_VALUE) {
            input.checked = false;
          }
        });
      } else {
        values.push(value);
        values = values.filter(value => value !== SKIP_VALUE);

        const skipInput = containerRef.current?.querySelector(
          `input[value="${SKIP_VALUE}"]`
        ) as HTMLInputElement;

        if (skipInput) {
          skipInput.checked = false;
        }
      }
    }

    setSelectedValues([...values]);

    if (values.length > 0) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  useEffect(() => {
    if (containerRef.current && values) {
      containerRef.current.style.setProperty(
        '--columns',
        `${values.length > 4 ? 4 : values.length}`
      );
    }
  }, [values]);

  return (
    <div className="radio-field" ref={containerRef}>
      {values?.map((value, index) => (
        <div
          key={index}
          className={`radio-field__card ${
            selectedValues.indexOf(value.value.toString()) > -1
              ? 'radio-field__card--active'
              : ''
          }`}
        >
          {value.image && (
            <picture
              className={`radio-field__picture ${
                value.isImage ? 'radio-field__picture--image' : ''
              }`}
            >
              <img src={value.image} alt={value.imageAlt} width="80" height="80" />
            </picture>
          )}
          <label className="radio-field__label" htmlFor={`${id}-${index}`}>
            {value.label}
          </label>
          <input
            className="field__checkbox-input radio-field__input"
            type="checkbox"
            name={fieldName}
            id={`${id}-${index}`}
            value={value.value}
            onChange={handleInputChage}
          />
        </div>
      ))}
    </div>
  );
};

export default CheckboxField;
